import { createWebHistory, createRouter } from "vue-router";
import store from "./store";


const 레이아웃 = () => {  return import ("./components/layout.vue")}
const 로그인 = () => {  return import ("./components/login.vue")}
const 견적조회 = () => {  return import ("./components/견적관리/견적조회.vue")}
const 견적등록 = () => {  return import ("./components/견적관리/견적등록.vue")}
const 견적수정 = () => {  return import ("./components/견적관리/견적수정.vue")}
const 견적확정 = () => {  return import ("./components/견적관리/견적확정.vue")}
const 권한관리 = () => {  return import ("./components/시스템관리/권한관리.vue")}
const 거래처관리 = () => {  return import ("./components/시스템관리/거래처관리.vue")}
const 사용이력관리 = () => {  return import ("./components/시스템관리/사용이력관리.vue")}
const 사용자설정 = () => {  return import ("./components/시스템관리/사용자설정.vue")}
const 수주등록요청 = () => {  return import ("./components/수주관리/수주등록요청.vue")}
const 수주요청승인 = () => {  return import ("./components/수주관리/수주요청승인.vue")}
const AS관리 = () => {  return import ("./components/수주관리/AS관리.vue")}
const 구매목록 = () => {  return import ("./components/구매관리/구매목록.vue")}
const 수주현황 = () => {  return import ("./components/생산관리/수주현황.vue")}
const 구동부생산 = () => {  return import ("./components/생산관리/구동부생산.vue")}
const 생산대기목록 = () => {  return import ("./components/생산관리/생산대기목록.vue")}
const 밸브조립 = () => {  return import ("./components/생산관리/밸브조립.vue")}
const 악세서리조립대기 = () => {  return import ("./components/생산관리/악세서리조립대기.vue")}
const 도장대기 = () => {  return import ("./components/생산관리/도장대기.vue")}
const 도장 = () => {  return import ("./components/생산관리/도장.vue")}
const 악세서리조립 = () => {  return import ("./components/생산관리/악세서리조립.vue")}
const 출하대기 = () => {  return import ("./components/출하관리/출하대기.vue")}
const 출하완료 = () => {  return import ("./components/출하관리/출하완료.vue")}
const 출하집계 = () => {  return import ("./components/출하관리/출하집계.vue")}
const 식별표 = () => {  return import ("./components/출하식별표.vue")}




const router = createRouter({
    history : createWebHistory(),
    routes : [
        {path:"/login",component:로그인},
        {path:"/print",component:식별표},
        {path:"/",component:레이아웃,meta:{requiresAuth:true},
        
        children:[
            {path:"/listES",component:견적조회},
            {path:"/registES",component:견적등록},
            {path:"/editES",component:견적수정},
            {path:"/confES",component:견적확정},
            {path:"/BS065E",component:권한관리},
            {path:"/BS040E",component:거래처관리},
            {path:"/BS050E",component:사용이력관리},
            {path:"/BS060E",component:사용자설정},
            {path:"/OD010",component:수주등록요청},
            {path:"/OD020",component:수주요청승인},
            {path:"/OD030",component:AS관리},
            {path:"/PC000",component:구매목록},
            {path:"/PD003",component:수주현황},
            {path:"/PD004",component:구동부생산},
            {path:"/PD005",component:생산대기목록},
            {path:"/PD010",component:밸브조립},
            {path:"/PD015",component:악세서리조립대기},
            {path:"/PD020",component:악세서리조립},
            {path:"/PD025",component:도장대기},
            {path:"/PD030",component:도장},
            {path:"/SH040",component:출하대기},
            {path:"/SH050",component:출하완료},
            {path:"/SH060",component:출하집계},
            
        ]},

    ]
});

var commonData = require('./constants.js')
var uri = commonData.URI


router.beforeEach(async function(to, from, next) {
    
    if (to.matched.some( function (routeInfo) {
       return routeInfo.meta.requiresAuth
     })) 
   {
       //로그인 여부 
       if (sessionStorage.getItem("userid") == null) {
           router.push({path:'/login'})
        }

       next()
   } 
   
   next()
})

export default router